<template>
  <div class="partner-detail">
    <div class="personal-info-panel">
      <div class="top">
        <div class="head-img">
          <img :src="userInfo.icon || defaultHead" alt="" />
        </div>
        <div class="name">
          <span>
            {{ userInfo.realname || userInfo.mobile || '' }}
          </span>
          <div class="status" v-if="userInfo.status">已实名</div>
          <div class="status" v-else>未实名</div>
        </div>
        <div @click="callPhone" class="phone">
          <img src="@/assets/img/icon-phone.png" />
        </div>
        <div @click="sendMsg" class="message">
          <img src="@/assets/img/icon-message.png" />
        </div>
      </div>
      <div class="bottom">
        <div>注册时间</div>
        <div>{{ userInfo.createTime | dateFormat('YYYY-mm-dd HH:MM:SS') }}</div>
      </div>
    </div>
    <div v-if="userInfo.status">
      <div class="calendar-selector" @click="showCalendar = true">
        <div class="selector">
          {{ startDate }} - {{ endDate }}
          <div class="icon">
            <img src="@/assets/img/icon-calendar.png" alt="" />
          </div>
        </div>
      </div>
      <div class="newly-added-merchant">
        <div>新增商户数（户）</div>
        <div class="details">
          <div v-for="(item, index) in activeObj" :key="index">
            <div>{{ item.remark || '' }}</div>
            <div>{{ item.allCount || 0 }}</div>
          </div>
        </div>
        <div class="count">
          <div>累计总商户数（户）</div>
          <div>{{ bCount || 0 }}</div>
        </div>
      </div>
      <div class="newly-added-partner">
        <div>新增伙伴数（人）</div>
        <div>{{ partnerObj.allCount || 0 }}</div>
      </div>
      <transaction-data
        :buTypeList="buTypeList"
        :tradeObj="tradeObj"
        :allMoney="allMoney"
        :showAllMoney="false"
      ></transaction-data>
    </div>
    <div v-else class="no-realname">
      伙伴未实名无数据，请联系尽快完成实名认证！
    </div>

    <van-calendar
      v-model="showCalendar"
      type="range"
      :default-date="defaultDate"
      :min-date="minDate"
      :max-range="31"
      :allow-same-day="true"
      color="#ecc381"
      @confirm="confirmCalendar"
      @close="onCloseCalendar"
    />
  </div>
</template>

<script>
import transactionData from '@/views/biz-components/transaction-data.vue'
import { dateFormat, platformAgent } from '@/utils/utils'
import {
  fetchMyPartnerBaseDetail,
  fetchMyPartnerStaticDetail
} from '@/api/partner/partner'
export default {
  components: { transactionData },
  filters: {
    dateFormat
  },
  data() {
    return {
      partnerId: this.$route.query.partnerId,
      showCalendar: false,
      startDate: '',
      endDate: '',
      minDate: new Date('2021-08-23'),
      maxDate: new Date(),
      defaultDate: [],
      userInfo: {},
      defaultHead: require('@/assets/img/icon-head.png'),
      activeObj: {},
      tradeObj: {},
      partnerObj: {},
      buTypeList: [],
      allMoney: 0,
      bCount: 0
    }
  },
  created() {
    let that = this
    SyHybridSdk.setNavRightBtn({
      params: {
        isShow: 1,
        label: '历史数据',
        func() {
          let params = {}
          if (platformAgent() === 'ios') {
            params = {
              hostName: 'PartnerDetailViewController',
              icon: that.userInfo.icon,
              id: that.partnerId
            }
          } else {
            params = {
              hostName:
                'com.jiuhongpay.worthplatform.mvp.ui.activity.PartnerDetailActivity',
              partner_detail_data: that.partnerId
            }
          }
          SyHybridSdk.openOriActivity({
            params,
            success: res => {}
          })
        }
      },
      success: res => {}
    })
    this.init()
  },
  methods: {
    init() {
      const start = new Date(this.getCurrMonthFirst())
      const end = new Date()
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.defaultDate = [start, end]
      fetchMyPartnerBaseDetail({
        partnerId: this.partnerId
      }).then(res => {
        this.userInfo = res || {}
        console.log(res)
      })
      this.queryDetail()
    },
    queryDetail() {
      let params = {
        partnerId: this.partnerId,
        startDate: this.startDate,
        endDate: this.endDate
      }
      console.log(params)
      fetchMyPartnerStaticDetail(params).then(res => {
        this.activeObj = res.active || {}
        this.tradeObj = res.trade || {}
        this.partnerObj = res.partner || {}
        this.buTypeList = res.buTypeList || []
        this.allMoney = res.allMoney || 0
        this.bCount = res.bCount || 0
        console.log(res)
      })
    },
    callPhone() {
      SyHybridSdk.callPhone({
        params: {
          phone: this.userInfo.mobile
        },
        success: res => {}
      })
    },
    sendMsg() {
      SyHybridSdk.sendMsg({
        params: {
          phone: this.userInfo.mobile,
          content: ''
        },
        success: res => {}
      })
    },
    confirmCalendar(date) {
      const [start, end] = date
      this.showCalendar = false
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.queryDetail()
    },
    onCloseCalendar() {},
    formatDate(date) {
      return dateFormat(date.getTime(), 'YYYY-mm-dd')
    },
    // 获取当月1号
    getCurrMonthFirst() {
      var myDate = new Date()
      var tYear = myDate.getFullYear()
      var tMonth = myDate.getMonth() + 1
      tMonth = this.doHandleZero(tMonth)

      return tYear + '-' + tMonth + '-01'
    },
    // 补零函数
    doHandleZero(zero) {
      var date = zero
      if (zero.toString().length == 1) {
        date = '0' + zero
      }
      return date
    }
  }
}
</script>
